import ace from 'brace';

ace.define('ace/theme/ivann', ['require', 'exports', 'module', 'ace/lib/dom'], (acequire, exports) => {
  // eslint-disable-next-line no-param-reassign
  exports.cssClass = 'ace-ivann';
  // eslint-disable-next-line no-param-reassign
  exports.cssText = '.ace-ivann .ace_gutter {'
    + 'background: var(--dark-grey);'
    + 'color: var(--grey);'
    + 'border-right: 1px solid var(--grey)'
    + '}'
    + '.ace-ivann .ace_print-margin {'
    + 'width: 1px;'
    + 'background: var(--grey)'
    + '}'
    + '.ace-ivann {'
    + 'background-color: var(--editor-grey);'
    + 'color: var(--foreground)'
    + '}'
    + '.ace-ivann .ace_cursor {'
    + 'color: #F8F8F0'
    + '}'
    + '.ace-ivann .ace_marker-layer .ace_selection {'
    + 'background: var(--background-alt)'
    + '}'
    + '.ace-ivann .ace_marker-layer .ace_step {'
    + 'background: rgb(102, 82, 0)'
    + '}'
    + '.ace-ivann .ace_marker-layer .ace_bracket {'
    + 'margin: -1px 0 0 -1px;'
    + 'border: 1px solid var(--foreground)'
    + '}'
    + '.ace-ivann .ace_marker-layer .ace_active-line {'
    + 'background: var(--background)'
    + '}'
    + '.ace-ivann .ace_gutter-active-line {'
    + 'background-color: #272727'
    + '}'
    + '.ace-ivann .ace_marker-layer .ace_selected-word {'
    + 'border: 1px solid #49483E'
    + '}'
    + '.ace-ivann .ace_invisible {'
    + 'color: #52524d'
    + '}'
    + '.ace-ivann .ace_entity.ace_name.ace_tag,'
    + '.ace-ivann .ace_keyword,'
    + '.ace-ivann .ace_meta.ace_tag,'
    + '.ace-ivann .ace_storage {'
    + 'color: var(--blue)'
    + '}'
    + '.ace-ivann .ace_punctuation,'
    + '.ace-ivann .ace_punctuation.ace_tag {'
    + 'color: #fff'
    + '}'
    + '.ace-ivann .ace_constant.ace_character,'
    + '.ace-ivann .ace_constant.ace_language,'
    + '.ace-ivann .ace_constant.ace_numeric,'
    + '.ace-ivann .ace_constant.ace_other {'
    + 'color: var(--pink)'
    + '}'
    + '.ace-ivann .ace_invalid {'
    + 'color: #F8F8F0;'
    + 'background-color: #F92672'
    + '}'
    + '.ace-ivann .ace_invalid.ace_deprecated {'
    + 'color: #F8F8F0;'
    + 'background-color: #AE81FF'
    + '}'
    + '.ace-ivann .ace_support.ace_constant,'
    + '.ace-ivann .ace_support.ace_function {'
    + 'color: var(--red)'
    + '}'
    + '.ace-ivann .ace_fold {'
    + 'background-color: var(--foreground);'
    + 'border-color: #F8F8F2'
    + '}'
    + '.ace-ivann .ace_storage.ace_type,'
    + '.ace-ivann .ace_support.ace_class,'
    + '.ace-ivann .ace_support.ace_type {'
    + 'font-style: italic;'
    + 'color: var(--red)'
    + '}'
    + '.ace-ivann .ace_entity.ace_name.ace_function,'
    + '.ace-ivann .ace_entity.ace_other,'
    + '.ace-ivann .ace_entity.ace_other.ace_attribute-name,'
    + '.ace-ivann .ace_variable {'
    + 'color: var(--seafoam)'
    + '}'
    + '.ace-ivann .ace_variable.ace_parameter {'
    + 'font-style: italic;'
    + 'color: var(--purple)'
    + '}'
    + '.ace-ivann .ace_string {'
    + 'color: var(--mustard)'
    + '}'
    + '.ace-ivann .ace_comment {'
    + 'color: var(--grey)'
    + '}'
    + '.ace-ivann .ace_fold-widget:hover {'
    + 'border-style: none'
    + '}';
});
